
































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import CFMDialog from '@/scripts/CFMDialog'
import * as blockui from '@/helpers/block-ui'
import CFMMultiselect from '@/components/partials/CFMMultiselect.vue'
import { required } from 'vuelidate/lib/validators'
import { mixinz } from '@/scripts/global/mixinz'
import moment from 'moment'

@Component<FailureModeTabDialog>({
  mixins: [mixinz],
  components: {
    'cfm-multiselect': CFMMultiselect,
  },
  validations() {
    return {
      startDate: { required },
      endDate: { required },
      deviceId: { required },
    }
  },
})
export default class FailureModeTabDialog extends CFMDialog {
  @Prop({ required: true }) workOrderId!: string;
  [x: string]: any

  loading: boolean = false
  isModalShown: boolean = false

  startDate: null | Date = null
  endDate: null | Date = null

  deviceObject: { DeviceId: number | null; Device: { Name: string; Id: number; IsActive: boolean } | null }[] = []

  faultModeObject: { FailureTypeId: number | null; FaultMode: { Name: string; Id: number; IsActive: boolean } | null } = {
    FailureTypeId: null,
    FaultMode: null,
  }
  description: string = ''

  capacityEquipmentList: { Name: string; Id: number }[] = []
  faultModeList: { Name: string; Id: number }[] = []

  get deviceId() {
    return this.deviceObject.length > 0 ? this.deviceObject[0].DeviceId : null
  }

  get calcDuration(): string {
    if (!this.startDate || !this.endDate) return '-'
    const diff = moment(this.endDate).diff(moment(this.startDate), 'minutes')
    if (diff < 0) return '-'
    const hours = Math.floor(diff / 60)
    const minutes = diff % 60
    if (hours > 0) return `${hours} sa ${minutes} dk`
    return `${minutes} dk`
  }
  public mounted() {
    $(this.$el).on('shown.bs.modal', () => {
      this.isModalShown = true
    })

    $(this.$el).on('hidden.bs.modal', () => {
      this.isModalShown = false
      this.editId = null
      this.startDate = null
      this.endDate = null
      this.description = ''
      this.deviceObject = []
      this.faultModeObject = { FailureTypeId : null, FaultMode: null }
      this.$v.$reset()
      this.$emit('close')
    })

    this.$eventHub.$on('editFailureMode', async ({ id, deviceName }: { id: number, deviceName: string }) => {
      this.editId = id
      await this.loadLists()
      this.showDialog()

      await new Promise<void>(resolve => {
        $(this.$el).one('shown.bs.modal', () => resolve())
      })

      await this.loadRecord(id)
    })
  }

  beforeDestroy() {
    this.$eventHub.$off('editFailureMode')
  }

  async created() {

  }
  async loadLists() {
    this.loading = true
    await Promise.all([
      this.getCapacityEquipmentList(),
      this.getFaultModeList(),
    ]).finally(() => {
      this.loading = false
    })
  }

  async getCapacityEquipmentList() {
    try {
      const response = await this.apiClient.device.capacityEquipmentGetCapacityEquipmentAndDeviceList()
      const list = response.data?.Data ?? response.data
      this.capacityEquipmentList = list.map((x: any) => ({
        Name: x.Name as string,
        Id: x.Id as number,
      }))
    } catch (e) { }
  }

  async getFaultModeList() {
    try {
      const response = await this.apiClient.failureType.failureTypeGetList()
      this.faultModeList = (response.data.Data ?? []).map((x: any) => ({
        Name: x.Name as string,
        Id: x.Id as number,
      }))
    } catch (e) {

    }
  }

  async loadRecord(id: number) {
    try {
      const response = await this.apiClient.failure.failureGetById({ id })
      const data = response.data

      this.editId = data.Id
      this.description = data.Description ?? ''
      this.startDate = data.StartDate ? moment(data.StartDate).toDate() : null
      this.endDate = data.EndDate ? moment(data.EndDate).toDate() : null

      if (data.DeviceId) {
        const device = this.capacityEquipmentList.find((x: any) => Number(x.Id) === Number(data.DeviceId))
        if (device) {
          this.deviceObject = [{ DeviceId: device.Id, Device: { Name: device.Name, Id: device.Id, IsActive: true } }]
        }
        else {
          const fallbackName = `Device #${data.DeviceId}`
          this.deviceObject = [{
            DeviceId: data.DeviceId,
            Device: { Name: fallbackName, Id: data.DeviceId, IsActive: true }
          }]
          this.capacityEquipmentList.push({ Name: fallbackName, Id: data.DeviceId })
        }
      }

      if (data.FailureTypeId) {
        const faultMode = this.faultModeList.find((x: any) => Number(x.Id) === Number(data.FailureTypeId))
        if (faultMode) {
          this.faultModeObject = {
            FailureTypeId: Number(faultMode.Id),
            FaultMode: { Name: faultMode.Name, Id: Number(faultMode.Id), IsActive: true }
          }
        } else {
          const fallbackName = data.FailureTypeName ?? `FailureType #${data.FailureTypeId}`
          this.faultModeObject = {
            FailureTypeId: Number(data.FailureTypeId),
            FaultMode: { Name: fallbackName, Id: Number(data.FailureTypeId), IsActive: true }
          }
          this.faultModeList.push({ Name: fallbackName, Id: Number(data.FailureTypeId) })
        }
      }
    } catch (e) {
      console.error('loadRecord error:', e)
    }
  }

  get StartDate() {
    if (this.startDate) {
      return moment(this.startDate).format(this.pickerDateTimeFormat)
    }
    return null
  }
  set StartDate(val: any) {
    if (val) {
      Vue.set(this, 'startDate', moment(val, this.pickerDateTimeFormat).toDate())
    } else {
      Vue.set(this, 'startDate', null)
    }
  }

  get EndDate() {
    if (this.endDate) {
      return moment(this.endDate).format(this.pickerDateTimeFormat)
    }
    return null
  }
  set EndDate(val: any) {
    if (val) {
      Vue.set(this, 'endDate', moment(val, this.pickerDateTimeFormat).toDate())
    } else {
      Vue.set(this, 'endDate', null)
    }
  }

  async onSubmit() {
    // this.$v.$touch()
    // if (this.$v.$invalid) return

    const isEdit = (this.editId ?? 0) > 0

    const formData = {
      Id: this.editId ?? 0,
      DeviceId: this.deviceObject[0]?.DeviceId ?? 0,
      DeviceIdList: isEdit ? null : this.deviceObject.map((d: any) => d.DeviceId).join(','),
      FailureTypeId: this.faultModeObject.FailureTypeId ?? null,
      StartDate: this.startDate,
      EndDate: this.endDate,
      Description: this.description?.trim() || null,
      WorkOrderId: Number(this.workOrderId),
    }

    blockui.blockElement(this, this.$el)
    try {
      const response = await this.apiClient.failure.failureSave(formData)
      if (response.data.IsSuccess) {
        toastr.success(this.translate('save_successfully'))
        this.$eventHub.$emit('failureModeAdded')
        this.$eventHub.$emit('reloadTabCounts', { workOrderId: this.workOrderId })
        this.saveSucceeded()
        this.close()
      } else {
        toastr.error(response.data.Message ?? 'Error')
      }
    } catch (e: any) {
      toastr.error(e)
    } finally {
      blockui.unBlockElement(this.$el)
    }
  }
}
